import axios from 'axios';
import authenticationService, { showSessionExpiredAlert } from '../services/authentication_service';
import { urls, commonConfigs } from '../../config';
import { getLocalAccessToken, getLocalRefreshToken, removeUser } from '../services/local_service';

const instance = axios.create({
  baseURL: urls.prodUrl, // Production base URL
  headers: {
    'Content-Type': 'application/json',
    // ...commonConfigs.prodApiHeader, // Production headers
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (res) => {
    if (res.data.status == 'success') {
      return res;
    } else {
      return Promise.reject('failure in status');
    }
  },
  async (err) => {
    const originalConfig = err.config;
    if (err.response && err.response.status === 401) {
      const refreshToken = getLocalRefreshToken();
      if (refreshToken && !originalConfig._retry) {
        console.log('IS IN HERE NOW');
        originalConfig._retry = true;
        try {
          // throw new Error('Session expired'); // Simulate session expiration
          const result = await authenticationService.refreshAccessToken();

          if (result !== true) {
            throw result;
          }
          return instance(originalConfig);
        } catch (error) {
          if (showSessionExpiredAlert()) {
            removeUser();
            window.location.href = '/login/developer';
          }
          
          return Promise.reject(error);
        }
      } else {
        if (showSessionExpiredAlert()) {
          removeUser();
          window.location.href = '/login/developer';
        }

        return Promise.reject(err)
      }
    }

    return Promise.reject(err.response.data.result.message);
  },
);

export default instance;